import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';

import Members from 'components/NextconLabMembers/Members';
import { useEffect } from "react";

function Home() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <Members />
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <Members />
        <Footer />
      </>
    )}
    </>
  );
}

export default Home;
